import React, { FunctionComponent, useEffect, useRef, useState, } from "react";
import { connect, useDispatch } from "react-redux";
import DispositionWhatsappTemplates from "../../Components/MarketingAutomation/DispositionWhatsappTemplates/DispositionWhatsappTemplates";
import styles from "./SetupWhatsappTemplates.module.css";
import { pushToGA } from "../../Services/users";

type props = {
    user: any;
};

const SetupWhatsappTemplates: FunctionComponent<props> = ({ user }) => {

    const dispatcher = useDispatch();

    useEffect(() => {
        if (user?.uid && user?.profile) {
            pushToGA(
                "event_tracking",
                "read pro",
                "read pro",
                "page load",
                user,
                "Setup_Whatsapp_Templates_Tab"
            )
        }
    }, [user])

    return (
        <div className={styles.setupWhatsappTemplatesContainer}>
            <div className={styles.setupWhatsappTemplatesContent}>
                <div className={styles.setupWhatsappTemplatesTitle}>Setup WhatsApp Templates</div>
                <div className={styles.setupWhatsappTemplatesText}>Selected templates will be used to share updates to clients</div>
            </div>
            <DispositionWhatsappTemplates  selectedTemplatesType={"Disposition based"} screen={"Setup Templates"} />
            {/* <div className={styles.saveContainer}>
                <div className={styles.saveSubContainer}>
                    <p>Note : Plan will only get activated once template setup is complete for each lead status.</p>
                    <button className={styles.saveButton}>Save & Submit</button>
                </div>
            </div> */}
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(SetupWhatsappTemplates);